import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Box,
    Button,
    Collapse,
    Divider,
    IconButton,
    Link,
    Typography,
} from '@mui/material';
import { useState } from 'react';

type ErrorPageProps = {
    status: number;
    title: string;
    stack?: string;
};

const ErrorPage = ({ status, title, stack }: ErrorPageProps) => {
    const [showStack, setShowStack] = useState(false);
    return (
        <Box
            height="100vh"
            width="100vw"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={1}
            >
                <Box display="flex" gap={2} alignItems="center">
                    <Typography variant="h3">{status}</Typography>
                    <Divider
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        sx={{ height: 60 }}
                    />
                    <Typography width={300}>{title}</Typography>
                </Box>
                {stack && (
                    <Box width="100%" mt={2}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ cursor: 'pointer' }}
                            onClick={() => setShowStack(!showStack)}
                        >
                            <Typography variant="body2" color="text.secondary">
                                Technical Details
                            </Typography>
                            <IconButton size="small">
                                {showStack ? (
                                    <ExpandLessIcon />
                                ) : (
                                    <ExpandMoreIcon />
                                )}
                            </IconButton>
                        </Box>
                        <Collapse in={showStack}>
                            <Box
                                sx={(theme) => ({
                                    backgroundColor: theme.palette.action.hover,
                                    borderRadius: 1,
                                    p: 2,
                                    mt: 1,
                                    maxHeight: '200px',
                                    overflow: 'auto',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-all',
                                })}
                            >
                                {stack}
                            </Box>
                        </Collapse>
                    </Box>
                )}
                <Button
                    fullWidth
                    component={'a'}
                    href={'/'}
                    sx={(theme) => ({
                        backgroundColor: theme.palette.action.hover,
                    })}
                >
                    Get back
                </Button>

                <Box position="absolute" bottom={40} p={3} maxWidth={500}>
                    <Typography textAlign="center" variant="body2" mb={1}>
                        We&apos;ve captured the error. Please try again.
                    </Typography>
                    <Typography textAlign="center" variant="body2">
                        If the problem persists or you need help from our
                        customer support, please contact{' '}
                        <Link href="mailto:support@mvision.ai">
                            support@mvision.ai
                        </Link>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default ErrorPage;
